import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import './SearchBox.scss'

export default function SearchBox({
  disabled = false,
  onChange = () => {},
  placeholder = 'Search',
  type = '',
  value = '',
}) {
  const [searchText, setSearchText] = useState('')
  const [isFocus, setIsFocus] = useState(false)
  const [searchBoxClasses, setSearchBoxClasses] = useState('')

  useEffect(() => {
    let classes = 'searchbox-container'
    if (isFocus) {
      classes = `${classes} searchbox-focus`
    } else {
      classes = `${classes} searchbox-normal`
    }
    if (disabled) {
      classes = `${classes} searchbox-bg-disabled`
    } else {
      classes = `${classes} searchbox-bg`
    }
    setSearchBoxClasses(classes)
  }, [isFocus, disabled])

  useEffect(() => {
    handleChangeSearch(value)
  }, [value])

  const handleChangeSearch = (text) => {
    if (onChange) {
      onChange(text)
    }
    setSearchText(text)
  }

  const handleCloseClick = () => {
    setSearchText('')
    onChange('')
  }

  return (
    <div className="searchbox-holder">
      <div
        className={`searchbox-container ${searchBoxClasses} ${
          type === 'messages' ? 'messages' : ''
        }`}
      >
        {!searchText && (
          <div className="search-icon-container">
            <i
              className="fa-sharp fa-magnifying-glass"
              style={{ fontSize: '0.8em', marginTop: '4px' }}
            ></i>
          </div>
        )}
        <div className="input-container">
          <input
            className="input-search"
            disabled={disabled}
            onBlur={() => setIsFocus(false)}
            onChange={(e) => handleChangeSearch(e.target?.value)}
            onFocus={() => {
              setIsFocus(true)
            }}
            placeholder={placeholder}
            type="text"
            value={searchText}
          />
        </div>

        {searchText && (
          <div className="close-icon-container">
            <i
              className="far fa-xmark"
              style={{ cursor: 'pointer' }}
              onClick={handleCloseClick}
            ></i>
          </div>
        )}
      </div>
    </div>
  )
}

SearchBox.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
}
